export const LOAD_CMS_BANNERS = 'LOAD_CMS_BANNERS'
export const LOAD_CMS_BANNERS_SUCCESS = 'LOAD_CMS_BANNERS_SUCCESS'
export const LOAD_CMS_BANNERS_FAILED = 'LOAD_CMS_BANNERS_FAILED'

export const LOAD_CMS_MESSAGES = 'LOAD_CMS_MESSAGES'
export const LOAD_CMS_MESSAGES_SUCCESS = 'LOAD_CMS_MESSAGES_SUCCESS'
export const LOAD_CMS_MESSAGES_FAILED = 'LOAD_CMS_MESSAGES_FAILED'
